import { ReactNode } from 'react'
import { twMerge } from 'src/utils/tw-merge.util'

interface Props {
  iconUrl?: string
  icon?: ReactNode | null
  children?: ReactNode
  sectionTitle: string
  titleClassName?: string
}

const SectionTitle = ({ iconUrl, icon, children, sectionTitle, titleClassName }: Props) => {
  return (
    <div className="c-flex c-flex-row c-gap-2 c-py-1">
      {iconUrl && <img src={iconUrl} alt="" width={24} height={24} />}
      {icon}
      {children}
      <h2 className={twMerge('c-m-0 c-p-0 c-h-[24px] c-font-semibold c-text-[1rem]', titleClassName)}>
        {sectionTitle} :
      </h2>
    </div>
  )
}

export default SectionTitle
